import "bootstrap/dist/css/bootstrap.min.css";
import { FilterMatchMode, FilterOperator, FilterService } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useRef, useState } from 'react';
import Base64Downloader from 'common-base64-downloader-react';
import apis from '../../api';
import '../../DataTableDemo.css';
import useParamsElectronicPayroll from '../../helpers/useParamsElectronicPayroll';
import dateFormat from '../../services/DateFormat.service';
import Video from '../Video/Video';
import './ElectronicPayroll.css';
import { Form, FormGroup, Forms, Label } from './ElectronicPayroll.styles';
import useParamsSilog from "../../helpers/useParamsSilog";
import { tableDate, timeToDate } from "../../services/tableDate.service";
import { Link, useHistory } from "react-router-dom";
import { async } from "rxjs";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { excelReport } from "../../services/excelReport.service";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : ElectronicPayroll
Description : Consulta de nómina electrónica
Date Autor Modification
================================================================================
28/03/2022 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente y sus funciones.
================================================================================ */


export default function ElectronicPayroll() {

  /*Listas de valores del componente*/
  const [listaCalendario, setListaCalendario] = useState([]);

  /*Propiedades del componente*/
  const [calendario, setCalendario] = useState("");
  const [consultado, setConsultado] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [PDF, setPDF] = useState("");
  const [contrato, setContrato] = useState("");
  const [prefijo, setPrefijo] = useState("");
  const [numeroDian, setNumeroDian] = useState("");

  /*Constantes globales para el componente*/
  const [nomina, setNomina] = useState([])
  const [planoSilog, setPlanoSilog] = useState([])
  const [params] = useParamsElectronicPayroll();
  const [paramsSilog] = useParamsSilog()

  const [isOpenNE, setIsOpenNE] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenTransferir, setIsOpenTransferir] = React.useState(false);
  const [isOpenRepasar, setIsOpenRepasar] = React.useState(false);
  const [isOpenAcum, setIsOpenAcum] = React.useState(false);
  const [isOpenPDF, setIsOpenPDF] = React.useState(false);
  const [isOpenSilog, setIsOpenSilog] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);
  const [loading9, setLoading9] = useState(false);
  const [loading10, setLoading10] = useState(false);
  const [loading11, setLoading11] = useState(false);
  const [loading12, setLoading12] = useState(false);
  const [loading13, setLoading13] = useState(false);
  const [loading14, setLoading14] = useState(false);
  const [loading15, setLoading15] = useState(false)

  const [rowState, setRowState] = useState([]);

  const elementWidth = { width: "20rem", justifySelf: "center" }
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  /*Propiedades de la tabla del componente*/
  const [rowDataLogs, setRowDataLogs] = useState([]);
  const [rowsLogs, setRowsLogs] = useState([]);
  const [first2Logs, setFirst2Logs] = useState(0);
  const [rows2Logs, setRows2Logs] = useState(10);
  const [selectedRowsLogs, setSelectedRowsLogs] = useState(null);
  const [filters1Logs, setFilters1Logs] = useState(null);

  const toast = useRef(null);
  let history = useHistory();

  const [errorRows, setErrorRows] = useState([])
  const [isOpenErrors, setIsOpenErrors] = useState(false)

  useEffect(() => {
    /*Se cargan los datos de las listas de valores del componente*/
    loadCalendar()
  }, []);

  useEffect(() => {
    const validateDian = async () => {
      await apis.validateDIANProcess(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
        console.log(res.data)
      }).catch(res => {
        toast.current.show({
          severity: 'warn', summary: 'Aviso', detail: (
            <div className="flex flex-column" style={{ flex: '1' }}>
              {res.response.data.message} <Link to='/ProcessDIAN'>Hazlo aquí</Link>
            </div>), sticky: true
        });
      })
    }
    validateDian()
  }, []);

  useEffect(() => {
    /*Se incializan las propiedades del componente*/
    const payrollTemplate = async () => {
      let plantilla = []
      params.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setNomina(plantilla)
    }
    payrollTemplate()
  }, [params]);

  useEffect(() => {
    /*Se incializan las propiedades del componente*/
    const plainTemplate = async () => {
      if (localStorage.getItem('facturaTech') === 'N') {
        let plantilla = []
        paramsSilog.forEach((p, index) => {
          if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
            plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
          }
          else {
            plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
          }
        })
        console.log(plantilla)
        setPlanoSilog(plantilla)
      }
    }
    plainTemplate()
  }, [paramsSilog]);

  const showModalNE = () => {
    setIsOpenNE(true);
  };

  const hideModalNE = () => {
    setIsOpenNE(false);
  };

  const showModal = () => {
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const showModalTransferir = () => {
    setIsOpenTransferir(true);
  };

  const hideModalTransferir = () => {
    setIsOpenTransferir(false); //
  };

  const showModalRepasar = () => {
    setIsOpenRepasar(true);
  };

  const hideModalRepasar = () => {
    setIsOpenRepasar(false); //
  };

  const showModalAcum = () => {
    setIsOpenAcum(true);
  };

  const hideModalAcum = () => {
    setIsOpenAcum(false);
  };

  const showModalPDF = () => {
    setIsOpenPDF(true);
  };

  const hideModalPDF = () => {
    setIsOpenPDF(false);
  };

  const showModalSilog = () => {
    setIsOpenSilog(true);
  };

  const hideModalSilog = () => {
    setIsOpenSilog(false);
  };

  /*Funciones que manejan el comportamiento de la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        {localStorage.getItem("facturaTech") === "N" && <Button label="Plano SilogTran" loading={loading13} className="p-button-sucess mr-2 p-button-sm" onClick={() => { setLoading13(true); showModalSilog() }} />}
        <Button label="Transferir" loading={loading1} className="p-button-sucess mr-2 p-button-sm" disabled={registros.length < 1} onClick={() => { setLoading1(true); postTransfer() }} />
        <Button label="Obtener CUNE" loading={loading9} className="p-button-primary mr-2 p-button-sm" disabled={registros.length < 1} onClick={() => { setLoading9(true); putCune() }} />
        <Button label="Reporte nómina electrónica" icon="pi pi-file-excel" className="p-button-sucess mr-2 p-button-sm"
          onClick={() => showModalNE()} />
      </React.Fragment>
    )
  }

  const leftToolbarTemplate = () => {
    return (
      <Button label="Consultar" disabled={!calendario} loading={loading2} className="p-button-sucess mr-2 p-button-sm" onClick={() => { setLoading2(true); setTabla() }} />
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </IconField>
      </div>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div style={{ width: "10rem" }}>
        <Button icon="pi pi-arrow-right" className="p-button-warning mr-1 p-button-sm text-xs" tooltip="Transferir registro" tooltipOptions={{ position: 'top' }} onClick={() => { setRegistros([rowData]); showModalTransferir() }} />
        <Button icon="pi pi-sync" className="p-button-warning p-button-sm text-xs" tooltip="Obtener CUNE" tooltipOptions={{ position: 'top' }} onClick={() => { setRegistros([rowData]); showModalRepasar() }} />
        {rowData.STATUS_TRANSFER === "ENVIADO" ?
          <Button icon="pi pi-file-pdf" className="p-button-danger p-button-sm text-xs ml-1" tooltip="Consultar PDF" tooltipOptions={{ position: 'top' }}
            loading={rowState[rowData.rowId]} onClick={() => { setRowState({ ...rowState, [rowData.rowId]: true }); getPDF(rowData.rowId, rowData.ID, rowData.CONTRACT, rowData.PREFIX, rowData.NRO_DOC_DIAN) }}
          />
          : null
        }
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
    setRegistros([]);
  }

  const initFilters1 = () => {
    /*Filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTRACT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CUNE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NRO_DOC_DIAN': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'DOCU_DIAN': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'PREFIX': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CREATION_USER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CREATION_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS_TRANSFER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TRANSFER_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'MONTH': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'YEAR': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  function handleSubmit(event) {
    event.preventDefault();
  }

  /*async function limpiar(){
    setCalendario("");
    setConcepto("");
    setContrato("");
    setAno("");
    setMes("");
    setConsultado(false)
  }*/

  const showConfirm = (id, process) => {
    /*Función encargada de mostrar al usuario un mensaje de confirmación de la realización de un proceso*/
    toast.current.show({
      severity: 'success', content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
            <p>Proceso {process}({id}) realizado existosamente</p>
          </div>
        </div>
      )
    });
  }

  const loadCalendar = async () => {
    await apis.getValueListCalendar("NIE", headers).then(res => {
      let calendarios = res.data["CALENDAR"]
      setListaCalendario(calendarios)
    })
  }

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario.ID_CALENDAR

    try {
      await apis.getTransferDataElectronicPayroll(_entity, _cliente, _calendario, headers).then(res => {
        if (res.data["DATA_NE"].length > 0) {
          let data = res.data["DATA_NE"]
          let rows = []
          let states = {}
          let rowCounter = 0
          data.forEach(element => {
            let fechaCreacion = tableDate(element.CREATION_DATE)
            let fechaTransferencia = tableDate(element.TRANSFER_DATE)
            let row = {
              rowId: rowCounter,
              ...element,
            }
            row["CREATION_DATE"] = fechaCreacion
            row["TRANSFER_DATE"] = fechaTransferencia
            states = {
              ...states,
              [rowCounter]: false
            }
            rows.push(row)
            rowCounter++
          })
          console.log(rows)
          setRowState(states)
          setRows(rows)
          setRowData(rows)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Consulta exitosa' });
        }
        else {
          setRows([])
          setRowData([])
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Consulta sin resultados' });
        }
        setLoading2(false)
      })
    }
    catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function setTablaLogs() {
    /*Función encargada de cargar la  información de la tabla de procesos */
    const _calendario = calendario.ID_CALENDAR;
    try {
      await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
        if (res.data["PROCESS"].length > 0) {
          let data = res.data["PROCESS"]
          setRowsLogs(data)
          setRowDataLogs(data)
          setConsultado(true)
        }
        else {
          setRowsLogs([])
          setRowDataLogs([])
        }
        setLoading7(false)
        setLoading8(false)
      })
      showModal()
    }
    catch (err) {
      setLoading7(false)
      setLoading8(false)
    }
  }

  async function process(action) {
    /*Función encargada de validar cuál proceso se desea realizar*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario.ID_CALENDAR

    const p = {
      ID_CALENDAR: _calendario,
      CLIENT: _cliente,
      ENTITY: _entity,
      ACTION: action
    }
    let msg = ""
    if (action == "PRO") {
      msg = "Procesar"
    }
    else {
      if (action == "CLO") {
        msg = "Cerrar"
      }
    }
    try {
      await apis.executeProcess(p, headers).then(res => {
        console.log('Procesado')
        loadCalendar()
      })
      setTimeout(() => {
        apis.getExecutedProcess(_entity, _calendario, _cliente, action, headers).then(res => {
          if (res.data.PROCESS.length > 0) {
            let data = res.data.PROCESS[0]
            let id = data.ID
            setLoading3(false)
            setLoading4(false)
            setLoading15(false)
            setRowDataLogs(res.data.PROCESS)
            setRowsLogs(res.data.PROCESS)
            // setTabla()
            showConfirm(id, msg)
          }
          else {
            setLoading3(false)
            setLoading4(false)
            setRowDataLogs([])
            setRowsLogs([])
            setLoading15(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Nada por procesar", sticky: true });
          }
        })
        setTabla()
        loadCalendar()
        hideModalAcum()
        if (action == "CLO") {
          setCalendario("")
        }
      }, 1000)
    }
    catch (err) {
      setLoading3(false)
      setLoading4(false)
      setLoading15(false)
      toast.current.show({ severity: 'error', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postTransfer() {
    /*Función encargada de realizar la transferencia de registros a la nómina electrónica*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario.ID_CALENDAR
    let _registros = ""

    registros.forEach(reg => {
      _registros = _registros + (reg.ID + ",")
    })

    _registros = _registros.slice(0, -1)

    const tranfers = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CALENDAR: _calendario,
      XML_IDS: _registros
    }

    try {
      await apis.postTransferElectronicPayroll(tranfers, headers).then(res => {
        setLoading1(false)
        setLoading6(false)
        setTabla()
        hideModalTransferir(true)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Tranferencia realizada exitosamente" });
      })
    }
    catch (err) {
      setLoading1(false)
      setLoading6(false)
      hideModalTransferir(true)
      let msg = err.response.data.message.split(" ")
      let cod = msg.pop()
      let aviso = ""
      msg.forEach(e => {
        aviso += e + " "
      })
      let cod1 = cod.substring(0, Math.floor(cod.length / 2))
      let cod2 = cod.substring(Math.floor(cod.length / 2))
      aviso = aviso + " " + cod1 + " " + cod2
      setTabla()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: aviso, sticky: true });
    }
  }

  async function putCune() {
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = calendario.ID_CALENDAR
    let _registros = ""

    registros.forEach(reg => {
      _registros = _registros + (reg.ID + ",")
    })

    _registros = _registros.slice(0, -1)

    const cunes = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CALENDAR: _calendario,
      XML_IDS: _registros
    }

    try {
      await apis.putCune(cunes, headers).then(res => {
        setLoading9(false)
        setLoading10(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Proceso realizado exitosamente" });
        setTabla();
      })
    }
    catch (err) {
      setLoading9(false)
      setLoading10(false)
      setTabla()
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  /*Funciones encargadas de dar formato de moneda a los datos necesarios en la tabla*/

  async function postElectronicPayrollReport() {
    /*Función encargada de generar la información de un reporte de nómina electrónica*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    nomina.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }
    console.log(report)
    nomina.forEach(c => {
      c.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
      })
    })
    try {
      await apis.postReportElectronicPayroll(report, headers).then(res => {
        finalReport = res.data
        try {
          excelReport(finalReport, 'reporteNóminaElectrónica')
          setLoading5(false)
          setLoading6(false)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de nómina electrónica generado existosamente" });
          hideModalNE();
        }
        catch (err) {
          setLoading5(false)
          setLoading6(false)
          console.error(err.message);
        }
      })
    }
    catch (err) {
      console.log(err)
      setLoading5(false)
      setLoading6(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postConfReport() {
    /*Función encargada de cargar la informacion del reporte de configuración*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const option = "1"
    const params = [
      {
        PARAMETERS: [
          { LABEL: "pinEntity", VALUE: localStorage.getItem("entity") },
          { LABEL: "pinClient", VALUE: localStorage.getItem("client") }
        ]
      }
    ]
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: params
    }
    try {
      await apis.electronicPayrollConf(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, 'reporteConfiguracionNE')
        setLoading11(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de configuración generado existosamente" });
      })
    }
    catch (err) {
      console.log(err)
      setLoading11(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function plainSilog() {
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: [{ PARAMETERS: [] }]
    }
    let max = 0
    planoSilog.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({})
    }
    console.log(report)
    planoSilog.forEach(c => {
      c.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: c.LABEL, VALUE: c.CODE })
      })
    })
    try {
      await apis.plainFileSilog(report, headers).then(res => {
        finalReport = res.data
        try {
          excelReport(finalReport, 'planoSilogTran')
          setLoading13(false)
          setLoading14(false)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Plano SilogTran generado existosamente" });
          hideModalSilog();
        }
        catch (err) {
          setLoading13(false)
          setLoading14(false)
          console.error(err.message);
        }
      })
    }
    catch (err) {
      console.log(err)
      setLoading13(false)
      setLoading14(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function getPDF(id, register, contract, prefix, dian) {
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')

    try {
      await apis.getPDFFile(_entity, client, register, headers).then(res => {
        if (res.data.PDF) {
          const pdf = res.data.PDF.DATA
          const tipo = res.data.PDF_OUTPUT
          setPDF({ FILE: pdf, PDF_OUTPUT: tipo })
          setContrato(contract)
          setPrefijo(prefix)
          setNumeroDian(dian)
          showModalPDF()
        }
        else {
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'No hay documento disponible', sticky: true });
        }
      })
      setRowState({ ...rowState, [id]: false })
    }
    catch (err) {
      setRowState({ ...rowState, [id]: false })
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  /*Headers y footers de los modales del componente*/
  const footerNE = (
    <div>
      <Button label="Generar" loading={loading5} onClick={() => { setLoading5(true); postElectronicPayrollReport() }} />
    </div>
  );

  const headerNE = (
    <div>
      <h3>Parámetros reporte de nómina electrónica</h3>
    </div>
  )

  const footerSilog = (
    <div>
      <Button label="Generar" loading={loading14} onClick={() => { setLoading14(true); plainSilog() }} />
    </div>
  );

  const headerSilog = (
    <div>
      <h3>Parámetros plano SilogTran</h3>
    </div>
  )

  const footerTransferir = (
    <div>
      <Button label="Si" loading={loading6} onClick={() => { setLoading6(true); postTransfer() }} />
      <Button onClick={() => hideModalTransferir()}>No</Button>
    </div>
  );

  const headerTransferir = (
    <div>
      <h3>¿Desea transferir este registro?</h3>
    </div>
  )

  const footerRepasar = (
    <div>
      <Button label="Si" loading={loading10} onClick={() => { setLoading10(true); putCune() }} />
      <Button onClick={() => hideModalRepasar()}>No</Button>
    </div>
  );

  const headerRepasar = (
    <div>
      <h3>¿Desea repasar este registro?</h3>
    </div>
  )

  const headerAcum = (
    <div>
      <h3>¿Desea realizar la acumulación del proceso?</h3>
    </div>
  )

  const footerAcum = (
    <div>
      <Button label="Si" loading={loading4} onClick={() => { setLoading4(true); process("CLO") }} />
      <Button label="No" onClick={hideModalAcum} />
    </div>
  );

  const tableHeaderTransferir = (
    <div className="table-header">
      <Button icon="pi pi-refresh" loading={loading7} tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => { setLoading7(true); setTablaLogs() }} />
    </div>
  );

  const footerPDF = (
    <div>
      {PDF.PDF_OUTPUT === '1' ?
        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + PDF.FILE} downloadName={"Documento_" + localStorage.getItem("client") + "_" + contrato + "_" + prefijo + "_" + numeroDian} onDownloadSuccess={() => { hideModalPDF(); setLoading12(false); }}>
          <Button icon="pi pi-file-pdf" className="p-button-danger p-button-sm text-xs" label="Descargar" loading={loading12} onClick={() => setLoading12(true)} />
        </Base64Downloader>
        :
        <Button icon="pi pi-arrow-down" onClick={() => { window.open(PDF.FILE, "_blank"); hideModalPDF() }} />
      }
    </div>
  );

  const headerPDF = (
    <div>
      <h3>Descargar PDF</h3>
    </div>
  );

  const rowClassName = (rowData) => {
    return { 'error-row': (rowData["STATUS"] === "ERROR") };
  }

  const percentageBodyTemplate = (rowData) => {
    return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
  }

  const createDateTemplate = (rowData) => {
    const date = timeToDate(rowData.CREATION_DATE);
    return date
  }

  const transferDateTemplate = (rowData) => {
    const date = timeToDate(rowData.TRANSFER_DATE);
    return date
  }


  const header = (
    <div>
      <h3>Procesar nómina electrónica</h3>
    </div>
  )

  const actionBodyTemplateErrors = (rowData) => {
    console.log(rowData.ERRORS)
    return (
      <div>
        {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
      </div>
    )
  }

  const footer = (
    <>
      <div>
        <Button label="Procesar" disabled={calendario === ""} loading={loading3} className="p-button-sucess mr-2 p-button-sm" onClick={() => { setLoading3(true); process("PRO") }} />
        <Button label="Deshacer" disabled={calendario === ""} loading={loading15} className="p-button-sucess mr-2 p-button-sm" onClick={() => { setLoading15(true); process("REV") }} />
        <Button label="Cerrar" disabled={calendario === ""} className="p-button-sucess mr-2 p-button-sm" onClick={showModalAcum} />
      </div>
      {consultado === true ?
        <div className="datatable-style-demo">
          <DataTable className="text-xs" header={tableHeaderTransferir} value={rowsLogs} first={first2Logs} rows={rows2Logs} onPage={onCustomPage2}
            selection={selectedRowsLogs} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
            size="small" filters={filters1Logs} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
            rowClassName={rowClassName}
          >
            <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
            <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
            <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
            <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
            <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
            <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
            <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
            <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
            <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
            <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
            <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
          </DataTable>
        </div>
        : null}
    </>
  )


  /*Funciones que manejan los eventos que cambian los campos de entrada del componente*/
  function handleChange(e, d, index) {
    //console.log(e.value)
    setNomina(n => {
      let newNomina = [...n]
      console.log(index)
      console.log(n)
      newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeDate(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setNomina(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeText(e, d, index) {
    setNomina(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  function handleChangeSilog(e, d, index) {
    //console.log(e.value)
    setPlanoSilog(n => {
      let newNomina = [...n]
      console.log(index)
      console.log(n)
      newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeDateSilog(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setPlanoSilog(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }

  async function handleChangeTextSilog(e, d, index) {
    setPlanoSilog(n => {
      let newNomina = [...n]
      newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newNomina
    })
  }



  /*Renderizado del componente*/
  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={headerNE} footer={footerNE} visible={isOpenNE} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalNE}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {params.map((d, index) => {
            /*Generación dinámica de los campos de entrada del modal del componente*/
            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && nomina.length > 0 && typeof nomina[index] !== "undefined") {
              let label = d.LABEL;
              if (d.REQUIRED === "1") {
                label = label + "*"
              }
              switch (d.TYPE) {
                case "LIST":
                  let options = []
                  if (d.REQUIRED === "1") {
                    options = [...d.OPTIONS]
                  }
                  else {
                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                  }
                  return (<>
                    <Label htmlFor="label">{label}</Label>
                    <Dropdown
                      key={index}
                      style={elementWidth}
                      value={nomina[index]["NAME"]}
                      options={options}
                      filter showClear filterBy="NAME"
                      optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                      placeholder={nomina[index]["NAME"] ? nomina[index]["NAME"] : "Seleccione"}
                      onChange={(e) => handleChange(e, d, index)}
                    />
                  </>
                  );
                case "DATE":
                  return (<>
                    <Label htmlFor="label">{label}</Label>
                    <Calendar key={d} style={elementWidth} id="navigators" value={nomina[index].CODE}
                      onChange={(e) => handleChangeDate(e, d, index)}
                      locale="es" dateFormat="dd-mm-yy" showIcon placeholder={nomina[index].CODE}
                      yearRange="2010:2030" /></>
                  );
                default:
                  return (<>
                    <Label htmlFor="label">{label}</Label>
                    <InputText
                      key={d}
                      style={elementWidth}
                      id="label2"
                      type="text"
                      value={nomina[index]}
                      onChange={(e) => handleChangeText(e, d, index)}
                    /></>
                  )
              }
            }
          })}
        </Dialog>
        {localStorage.getItem("facturaTech") === "N" &&
          <Dialog header={headerSilog} footer={footerSilog} visible={isOpenSilog} bo
            position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalSilog}>
            <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
            {paramsSilog.map((d, index) => {
              /*Generación dinámica de los campos de entrada del modal del componente*/
              if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && planoSilog.length > 0 && typeof planoSilog[index] !== "undefined") {
                let label = d.LABEL;
                if (d.REQUIRED === "1") {
                  label = label + "*"
                }
                switch (d.TYPE) {
                  case "LIST":
                    let options = []
                    if (d.REQUIRED === "1") {
                      options = [...d.OPTIONS]
                    }
                    else {
                      options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                    }
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <Dropdown
                        key={index}
                        style={elementWidth}
                        value={planoSilog[index]["NAME"]}
                        options={options}
                        filter showClear filterBy="NAME"
                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                        placeholder={planoSilog[index]["NAME"] ? planoSilog[index]["NAME"] : "Seleccione"}
                        onChange={(e) => handleChangeSilog(e, d, index)}
                      />
                    </>
                    );
                  case "DATE":
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <Calendar key={d} style={elementWidth} id="navigators" value={planoSilog[index].CODE}
                        onChange={(e) => handleChangeDateSilog(e, d, index)}
                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={planoSilog[index].CODE}
                        yearRange="2010:2030" /></>
                    );
                  case "NUMBER":
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <InputText
                        key={d}
                        style={elementWidth}
                        id="label2"
                        type="text"
                        value={planoSilog[index]["CODE"]}
                        onChange={(e) => handleChangeTextSilog(e, d, index)}
                      /></>
                    )
                  default:
                    return (<>
                      <Label className="mt-1" htmlFor="label">{label}</Label>
                      <InputText
                        key={d}
                        style={elementWidth}
                        id="label2"
                        type="text"
                        value={planoSilog[index]["CODE"]}
                        onChange={(e) => handleChangeTextSilog(e, d, index)}
                      /></>
                    )
                }
              }
            })}
          </Dialog>
        }
        <Dialog header={header} visible={isOpen} bo maximizable footer={footer}
          position="top" style={{ width: "30rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
        </Dialog>
        <Dialog header={headerAcum} footer={footerAcum} visible={isOpenAcum} position="top"
          style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAcum} />
        <Dialog header={headerTransferir} footer={footerTransferir} visible={isOpenTransferir} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalTransferir}>
        </Dialog>
        <Dialog header={headerRepasar} footer={footerRepasar} visible={isOpenRepasar} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRepasar}>
        </Dialog>
        <Dialog header={headerPDF} footer={footerPDF} visible={isOpenPDF} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalPDF}>
        </Dialog>
        <Dialog header={"Errores"} visible={isOpenErrors}
          position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
          <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

            <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
              <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
            </DataTable>
          </div>
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Nómina electrónica</span>
          <Video header="Instructivo liquidación nómina electrónica" url={localStorage.getItem('ELECTRONICPAYROLL_VIDEO')} />
        </div>
        <Form onSubmit={handleSubmit}>
          <Forms>
            <div className="flex flex-row flex-wrap justify-content-between align-items-center align-content-center">
              <FormGroup>
                <Label htmlFor="label">Calendario nómina electrónica</Label>
                <div className="p-inputgroup">
                  <Dropdown value={calendario}
                    filter showClear filterBy="DETAIL" emptyMessage={"No hay calendarios disponibles"}
                    options={listaCalendario} placeholder={"Seleccione calendario"}
                    onChange={(e) => setCalendario(e.value)}
                    optionLabel='DETAIL'
                    style={{ width: "20rem", justifySelf: "center" }}
                  />
                  <Button className="mr-2 p-button-sm" icon='pi pi-cog' loading={loading8} disabled={!calendario} label="Generar nómina electrónica" onClick={() => { { setLoading8(true); setTablaLogs() } }} />
                </div>
              </FormGroup>
              <div>
                <Button style={{ height: '3rem', marginTop: '1rem' }} icon="pi pi-search" label="Consultar históricos"
                  className="mr-2 p-button-sm" onClick={() => history.push('/HistoricElectronicPayroll')} />
                <Button style={{ height: '3rem', marginTop: '1rem' }} icon="pi pi-file-excel" label="Configuración NE"
                  loading={loading11} className="p-button-success mr-2 p-button-sm" tooltip="Configuración nómina electrónica"
                  tooltipOptions={{ position: 'left' }} onClick={() => { setLoading11(true); postConfReport() }} />
              </div>
            </div>
          </Forms>
        </Form >
        <div className="card mt-4">
          <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
          <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
            selectionMode="multiple" selection={registros} onSelectionChange={(e) => setRegistros(e.value)} dataKey="ID"
            size="small" filters={filters1} filterDisplay="menu" onFilter={(e) => {
              setFilters1(e.filters);
              setRegistros([]);
            }}
            globalFilterFields={['ID', 'CONTRACT', 'NUMBER_ID', 'NAME', 'CUNE', 'NRO_DOC_DIAN', 'DOCU_DIAN', 'PREFIX', 'CREATION_USER', 'CREATION_DATE', 'STATUS_TRANSFER', 'TRANSFER_DATE', 'MONTH', 'YEAR']}
            header={header1} >
            <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
            <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
            <Column field="CONTRACT" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
            <Column field="NUMBER_ID" header="Número de documento" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
            <Column field="NAME" header="Nombre" filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '14rem' }} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
            <Column field="NRO_DOC_DIAN" header="Nro documento DIAN" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Concepto" sortable></Column>
            <Column field="DOCU_DIAN" header="Consecutivo novedad" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Consecutivo" sortable></Column>
            <Column field="PREFIX" header="Prefijo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre concepto" sortable></Column>
            <Column field="CREATION_DATE" header="Fecha de creación" body={createDateTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades" sortable></Column>
            <Column field="STATUS_TRANSFER" header="Estado transferencia" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Base" sortable></Column>
            <Column field="TRANSFER_DATE" header="Fecha transferencia" body={transferDateTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Valor" sortable></Column>
            <Column field="MONTH" header="Mes" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Consolidado" sortable></Column>
            <Column field="YEAR" header="Año" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="CUNE" header="CUNE" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Calendario" sortable></Column>
            <Column header="Acciones" headerStyle={{ width: '10rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', width: "10rem" }} body={actionBodyTemplate} />
          </DataTable>
        </div>
      </div >
    </div >
  );
}